import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    flatsRange: 11,
    otherRange: 0,
};
export const ammenitiesRangeSlice = createSlice({
    name: "ammenitiesRange",
    initialState,
    reducers: {
        flatsRange: (state, action) => {
            state.flatsRange = action.payload;

        },
        otherRange: (state, action) => {
            state.otherRange = action.payload;
        },
        clearAllRanges: (state) => {
            state.flatsRange = 0;
            state.otherRange = 0;
        },
    },
});
export const { flatsRange, clearAllRanges, otherRange } = ammenitiesRangeSlice.actions;
export default ammenitiesRangeSlice.reducer;
